import { useLoyaltyTierCopy } from "../../../../services/hooks/loyalty/useLoyaltyTierCopy";
import { useLoyaltyUiModel } from "../../../../services/hooks/useLoyaltyUiModel";
import { useTranslationI18 } from "../../../../services/hooks/useTranslationI18";
import { localizedNumber } from "../../../../utils/help/localization/localization";
import { LoyaltyPointsIcon } from "../../../global/Icons/LoyaltyPointsIcon";
import styles from "./LoyaltyPointsBalance.module.scss";

/**
 * The tier-themed points balance - "9726 points ✷" - shared by the Rewards tab
 * summary and the menu tab reward meter so the two stay identical.
 *
 * Figma 13764:81431 and 15404:112184 give both surfaces the same type: the
 * number at 35/600 in the tier colour, the unit at 14/400, and a 13px points
 * icon sitting on the number's baseline.
 */
export const LoyaltyPointsBalance = () => {
  const { t, i18n } = useTranslationI18();
  const { getPointLabel } = useLoyaltyTierCopy();
  const { displayPoints } = useLoyaltyUiModel(t("pointing-system:point"), i18n);

  return (
    <p className={styles.points_balance} data-testid="loyalty-points-balance">
      <strong>{localizedNumber(displayPoints)}</strong>
      <span>{getPointLabel(displayPoints)}</span>
      <LoyaltyPointsIcon />
    </p>
  );
};
